<mat-dialog-content class="stack-manager-container">
    @for (call of calls; track call.description; let i = $index) {
        <div>
            @if (!awaitConfirm) {
                @if (showModalWindowUrlCall(call, i)) {
                    <se-iframe-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        [debug]="debug"
                        [call]="call"
                        [dataStore]="dataStore ?? {}"
                    ></se-iframe-call>
                } @else if (showFormCall(call, i)) {
                    <se-form-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        [call]="call"
                        [debug]="debug"
                        [dataStore]="dataStore ?? {}"
                    >
                    </se-form-call>
                } @else if (showTabWindowUrlCall(call, i)) {
                    <se-tab-window-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        [debug]="debug"
                        [call]="call"
                        [dataStore]="dataStore ?? {}"
                    ></se-tab-window-call>
                } @else if (showRestCall(call, i)) {
                    <se-rest-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        [call]="call"
                        [debug]="debug"
                        [dataStore]="dataStore ?? {}"
                    ></se-rest-call>
                } @else if (showArrayFindCall(call, i)) {
                    <se-array-find-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        [call]="call"
                        [debug]="debug"
                        [dataStore]="dataStore ?? {}"
                    >
                    </se-array-find-call>
                } @else if (showNotificationCall(call, i)) {
                    <se-notification-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        (callNotify)="onNotify($event)"
                        [call]="call"
                        [debug]="debug"
                        [dataStore]="dataStore ?? {}"
                    >
                    </se-notification-call>
                } @else if (showErrorCall(call, i)) {
                    <se-error-call
                        (callEnd)="onCallEnd($event)"
                        (callThrowError)="onCallError($event)"
                        [call]="call"
                        [debug]="debug"
                        [dataStore]="dataStore ?? {}"
                    >
                    </se-error-call>
                }
            } @else {
                <div class="container">
                    <h2>{{ confirmText }}</h2>
                    <div class="tp-close">
                        <button (click)="confirmButtonClick()" mat-raised-button color="primary">
                            {{ confirmButtonLabel }}
                        </button>
                    </div>
                </div>
            }
        </div>
    }
</mat-dialog-content>
